<template>
	<div>
		<v-container>
			<v-select
				v-model="environmentSelect"
				:items="environments"
				item-text="description"
				item-value="id"
				label="Environment"
				:loading="loadingEnvironments"
			></v-select>
		</v-container>
		<v-list two-line subheader v-if="resources && resources.length > 0">
			<v-subheader>RESOURCES</v-subheader>
			<div v-for="(resource, i) in resources" :key="i">
				<v-list-item @click="clickResource(resource)">
					<v-list-item-content>
						<v-list-item-title>{{ resource.description }}</v-list-item-title>
						<v-list-item-subtitle
							v-if="resource.resourceStatus"
							class="text--primary"
							v-text="resource.resourceStatus.status"
						></v-list-item-subtitle>
						<v-list-item-subtitle
							v-if="
								resource.resourceStatus &&
									resource.resourceStatus.jobCode &&
									resource.resourceStatus.jobStageType == 'Opened'
							"
							>Job {{ resource.resourceStatus.jobCode }}</v-list-item-subtitle
						>
					</v-list-item-content>
					<v-list-item-action>
						<v-avatar
							:color="
								resource.resourceStatus
									? resource.resourceStatus.color
									: 'indigo'
							"
							size="46"
						></v-avatar>
					</v-list-item-action>
				</v-list-item>
				<v-divider></v-divider>
			</div>
		</v-list>
	</div>
</template>

<script>
	import resourceService from "@/services/resourceService";
	export default {
		data() {
			return {
				environmentSelect: {},
				environments: [],
				loadingEnvironments: false,
				loadingResources: false,
				resources: [],
				resourceSelected: {},
				resourceStatus: [],
				alert: { alerts: [], type: "error" },
			};
		},
		watch: {
			async environmentSelect() {
				await this.getResourceStatus();
				await this.getResources();
			},
		},
		methods: {
			async getResourceStatus() {
				let res = await this.$http.get("resource/status");
				if (res.success) this.resourceStatus = res.data;
				else this.alert.alerts = res.data;
			},
			navigateRegistryRegType() {
				let resourceStatus = this.resourceSelected.resourceStatus;
				this.$router.push({
					name: "Registry RegType",
					query: {
						environmentId: this.environmentSelect,
						environmentName: this.environments.filter(
							(e) => e.id == this.environmentSelect
						)[0].description,
						resourceId: this.resourceSelected.id,
						resourceName: this.resourceSelected.description,
						color: resourceStatus != null ? resourceStatus.color : null,
						regTypeId: resourceStatus != null ? resourceStatus.regTypeId : null,
						jobCode: resourceStatus != null ? resourceStatus.jobCode : null,
						jobStageType:
							resourceStatus != null ? resourceStatus.jobStageType : null,
					},
				});
			},
			clickResource(resource) {
				this.resourceSelected = resource;
				this.navigateRegistryRegType();
			},
			async getEnvironments() {
				this.loadingEnvironments = true;
				let res = await this.$http.get("user/environments");
				this.loadingEnvironments = false;
				if (res.success) {
					this.environments = res.data;
					if (this.environments && this.environments.length == 1) {
						this.environmentSelect = this.environments[0].id;
					}
					//if (this.environments.length > 0) {
					//  this.environmentSelect = this.environments[0];
					//  await this.getResources();
					//}
					// await this.getResources();
				}
			},

			// Seleciona o job "default";
			changeResourceStatus() {
				let resourceStatus = this.resourceStatus;
				this.resources.forEach((r) => {
					let rstatus = resourceStatus.filter((rs) => rs.resourceId == r.id)[0];
					r.resourceStatus = rstatus;
				});
			},

			// Retorna todos os recursos referente ao ambiente
			async getResources() {
				if (!this.environmentSelect) return;
				let res = await resourceService.getByEnvironmentId(
					this.environmentSelect,
					true
				);

				if (res.success) {
					this.resources = res.data.sort((a, b) => {
						if (a.seq > b.seq) return 1;
						else if (a.seq < b.seq) return -1;
						else return 0;
					});
					this.changeResourceStatus();
				}
			},
		},
		async mounted() {
			await this.getEnvironments();
		},
	};
</script>
